document.addEventListener("DOMContentLoaded", function () {
    let discountBtn = document.querySelector(".icart-coupon-code-svg");
    discountBtn.addEventListener("click", function () {
        this.classList.toggle("isActive")
        let discountForm = document.querySelector(".scDiscount__container");
        discountForm.classList.toggle("isActive")
    });
    let topSwiper = new Swiper('.top_swiper', {
        spaceBetween: 0,
        centeredSlides: true,
        loop: true,
        slidesPerView: 1,
        speed: 1000,
        autoplay: {
            delay: 3000,
        },
        navigation: {
            nextEl: '.top_swiper-next',
            prevEl: '.top_swiper-prev',
        }
    });
    let giftSwiper = new Swiper('.gift_swiper', {
        spaceBetween: 35,
        allowTouchMove:false,
        centeredSlides: true,
        slidesPerView: 1,
        loop: true,
        pagination: {
            el: '.gift_swiper-pagination',
            clickable: true,
            dynamicMainBullets: 3
        },
        navigation: {
            nextEl: '.gift_swiper-next',
            prevEl: '.gift_swiper-prev',
        }
    });
   
})
